import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AutoResizeTextArea,
  FormGroupLabel,
  FormItem,
  FormValueContainer,
  HintText,
  UnitSpan,
} from "../../../shared/components/form/FormElements";
import { Controller, useFormContext } from "react-hook-form";
import Error from "@/shared/components/form/Error";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import DatePicker from "react-datepicker";
import getUnixTime from "date-fns/getUnixTime";
import FormField from "../../../shared/components/form/FormField";
import { formInputStyles, formStyles } from "../../../shared/constants/styles";
import {
  CustomInput,
  Desc,
} from "../../Reminders/MaintenanceReminders/MaintenanceRemindersForm";
import {
  getDateFnsLocale,
  getDistanceFactor,
  getDistanceUnit,
  handleNegative,
  handleNumberInputOnWheelPreventChange,
  handleVehicleOnChange,
} from "../../../shared/helpers";
import FileUploader from "../../../shared/components/form/FileUploader";
import ImageWithZoom from "../../../shared/components/form/ImageWithZoom";
import { colorBlue, colorGray } from "../../../utils/palette";
import { FileUploaderContainer } from "../../Issues/IssuesForm";
import { dhm } from "../../WorkOrders";
import differenceInMilliseconds from "date-fns/differenceInMilliseconds";
import useFetchOdoHint from "../../../shared/custom-hooks/useFetchOdoHint";
import Tooltip from "../../../shared/components/Tooltip";
import { Icon } from "../../../shared/components/TableElements";
import { useLocation } from "react-router";
import InfoPopup from "../../../shared/components/InfoPopup";
import startOfDay from "date-fns/startOfDay";
import { postApi } from "../../../api/getUser";
import FileUploaderNew from "../../../shared/components/form/FileUploaderNew";
import SubscribeTooltipIcon from "../../../shared/components/SubscribeTooltipIcon";
import { useAuth } from "../../../contexts/AuthContext";
import useAutosizeTextArea from "../../../shared/custom-hooks/useAutosizeTextArea";
import SubscribePopup from "../../../shared/components/SubscribePopup";

const ScheduledTripDetailsForm = ({
  tripDocs,
  setTripDocs,
  rowData,
  firstTimeEdit,
  userOptions,
  setUserOptions,
  tripType,
}) => {
  const {
    handleSubmit,
    reset,
    register,
    control,
    watch,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useFormContext();
  const { t } = useTranslation("common");
  const location = useLocation();
  const vehiclesList = useSelector((state) => state.vehicles.list);
  const { userId } = useSelector((state) => state.user);
  const { tag } = useAuth();

  const users = useSelector((state) => state.users.list);
  const vehicles = vehiclesList
    .slice(1, vehiclesList.length)
    .filter((v) => v.veh_active === 1);

  //State to show subscribe popup
  const [showSubscribePopup, setShowSubscribePopup] = useState(false);
  const [subscribePopupMsg, setSubscribePopupMsg] = useState(
    t("subscribe_msg")
  );

  const firstNotiOptions = [
    { label: t("15_mins_before"), value: 1, mins: 15 },
    { label: t("30_mins_before"), value: 2, mins: 30 },
    { label: t("1_hour_before"), value: 3, mins: 60 },
    { label: t("3_hours_before"), value: 4, mins: 180 },
    { label: t("6_hours_before"), value: 5, mins: 360 },
    { label: t("12_hours_before"), value: 6, mins: 720 },
    { label: t("1_day_before"), value: 7, mins: 1440 },
  ];

  const [secondNotiOptions, setSecondNotiOptions] = useState(firstNotiOptions);

  const type = location?.state?.type;

  //Hook form variables
  const vehicle = watch("vehicle");
  const driver = watch("driver");
  //   const startingOdo = watch("startingOdo");
  //   const endingOdo = watch("endingOdo");
  const scheduledDeparture = watch("scheduledDeparture");
  const firstNotification = watch("firstNotification");
  const secondNotification = watch("secondNotification");
  const tripInstructions = watch("tripInstructions");
  const scheduledDepLocation = watch("scheduledDepLocation");
  const scheduledArrLocation = watch("scheduledArrLocation");

  const textAreaRef = useRef(null);
  useAutosizeTextArea(textAreaRef.current, tripInstructions);

  //   const { odoHint, odoUnit, lastOdoValue } = useFetchOdoHint({
  //     vehicle,
  //     filterDateEnd: getUnixTime(depDate),
  //   });

  //   const [showHighStartingOdoErr, setShowHighStartingOdoErr] = useState(false);
  //   const [showHighEndingOdoErr, setShowHighEndingOdoErr] = useState(false);

  //State to show hourly vehicle unavailable popup
  const [showNoHourlyVehiclePopup, setShowNoHourlyVehiclePopup] =
    useState(false);

  //   useEffect(() => {
  //     if (
  //       startingOdo &&
  //       endingOdo &&
  //       +endingOdo - +startingOdo > 1000 &&
  //       !firstTimeEdit.current
  //     ) {
  //       setShowHighEndingOdoErr(true);
  //     } else {
  //       setShowHighEndingOdoErr(false);
  //     }

  //     if (type === "edit" && firstTimeEdit.current) {
  //       setShowHighEndingOdoErr(false);
  //       firstTimeEdit.current = false;
  //     }
  //   }, [endingOdo, startingOdo]);

  return (
    <>
      {showSubscribePopup && (
        <SubscribePopup
          showPopup={showSubscribePopup}
          setShowPopup={setShowSubscribePopup}
          message={subscribePopupMsg}
        />
      )}
      {showNoHourlyVehiclePopup && (
        <InfoPopup
          showPopup={showNoHourlyVehiclePopup}
          setShowPopup={setShowNoHourlyVehiclePopup}
          message={t("no_support_for_trips_with_hrs_msg")}
          icon={{ className: "fi fi-rr-info", color: colorBlue }}
          actionIcon={{
            handler: () => {
              setShowNoHourlyVehiclePopup(false);
            },
            label: t("ok"),
          }}
        />
      )}
      <Container className="px-4 pb-4">
        <Row>
          <Col>
            <Row>
              <Col md={4}>
                <FormGroupLabel>{t("vehicle")}</FormGroupLabel>
                <Controller
                  name="vehicle"
                  control={control}
                  //errors={errors}
                  render={({ field: { onChange, value, ref } }) => (
                    <Select
                      options={vehicles}
                      //value={vehicles.find((c) => c.value === value)}
                      value={value}
                      onChange={(veh) => {
                        if (veh.primary_meter === "Hours") {
                          setShowNoHourlyVehiclePopup(true);
                          setValue("vehicle", "");
                        } else {
                          handleVehicleOnChange(
                            veh,
                            onChange,
                            "", //sending userKey as empty string since driver should not be set for scheduled trips
                            setValue,
                            setUserOptions,
                            userId
                          );
                        }
                      }}
                      //onCreateOption={handleCreate}
                      placeholder={t("vehicle_placeholder")}
                      styles={formStyles}
                      isDisabled={rowData?.veh_id && rowData?.trip_status === 1}
                    />
                  )}
                  rules={{ required: t("required_err") }}
                />

                {errors?.vehicle && <Error error={errors.vehicle.message} />}
              </Col>
              <Col md={2}></Col>

              {vehicle && (
                <Col md={4}>
                  <FormGroupLabel>{t("assign_to_driver")}</FormGroupLabel>
                  <Controller
                    name="driver"
                    control={control}
                    //errors={errors}
                    render={({ field: { onChange, value, ref } }) => (
                      <Select
                        options={userOptions}
                        //value={vehicles.find((c) => c.value === value)}
                        value={value}
                        onChange={onChange}
                        //onCreateOption={handleCreate}
                        placeholder={t("select_a_driver")}
                        styles={formStyles}
                        isDisabled={
                          rowData?.trip_by && rowData?.trip_status === 1
                        }
                        isClearable
                      />
                    )}
                    //rules={{ required: t("required_err") }}
                  />

                  {errors?.driver && <Error error={errors.driver.message} />}
                </Col>
              )}
            </Row>

            {vehicle && (
              <>
                <Row>
                  <Col md={10}>
                    <hr className="mt-4 mb-0 p-0" />
                  </Col>
                </Row>

                <Row>
                  <Col md={4}>
                    <FormGroupLabel>{t("scheduled_departure")}</FormGroupLabel>
                    <Controller
                      name="scheduledDeparture"
                      //defaultValue={new Date()}
                      control={control}
                      render={({ field: { onChange, value, ref } }) => (
                        <DatePicker
                          minDate={new Date()}
                          //minDate={new Date()}
                          selected={value}
                          locale={getDateFnsLocale()}
                          dateFormat={"P h:mm aa"}
                          showMonthDropdown
                          showYearDropdown
                          onChange={onChange}
                          showTimeInput
                          customInput={
                            <CustomInput
                              clearable={true} //Not clearable but class added to maintain styling consistency with arrDate
                              //disabled={status == 1 || status == 2}
                            />
                          }
                          placeholderText={t("scheduled_departure")}

                          //disabled={status == 1 || status == 2}
                        />
                      )}
                      rules={{
                        required: t("required_err"),
                      }}
                    />
                    {errors?.scheduledDeparture && (
                      <Error error={errors.scheduledDeparture.message} />
                    )}
                  </Col>
                  <Col md={2}></Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroupLabel>{t("dep_loc")}</FormGroupLabel>
                    <FormItem
                    //disabled={status == 2}
                    //tabIndex={0}
                    >
                      <FormField
                        name="scheduledDepLocation"
                        control={control}
                        component="input"
                        rules={{ required: t("required_err") }}
                        defaultValue=""
                        //isAboveError={isAboveError}
                        placeholder={t("dep_loc")}
                        style={formInputStyles}
                        //disabled={status == 2}
                        //onKeyUp={handleSIOdoChange}
                      />
                    </FormItem>

                    {errors?.scheduledDepLocation && (
                      <Error error={errors.scheduledDepLocation.message} />
                    )}
                  </Col>
                  <Col md={2}></Col>

                  <Col md={4}>
                    <FormGroupLabel>{t("arr_loc")}</FormGroupLabel>
                    <FormItem
                    //disabled={status == 2}
                    //tabIndex={0}
                    >
                      <FormField
                        name="scheduledArrLocation"
                        control={control}
                        component="input"
                        //rules={{ required: t("required_err") }}
                        defaultValue=""
                        //isAboveError={isAboveError}
                        placeholder={t("arr_loc")}
                        style={formInputStyles}
                        //disabled={status == 2}
                        //onKeyUp={handleSIOdoChange}
                      />
                    </FormItem>

                    {errors?.scheduledArrLocation && (
                      <Error error={errors.scheduledArrLocation.message} />
                    )}
                  </Col>
                </Row>

                <Row>
                  <Col md={10}>
                    <hr className="mt-4 mb-4 p-0" />
                  </Col>
                </Row>

                <Row>
                  <Col md={10}>
                    <div className="d-flex align-items-center">
                      <h5>{t("driver_notifications")}</h5>
                      {tag === "free-user" && (
                        <div style={{ marginBottom: "0.1rem" }}>
                          <SubscribeTooltipIcon
                            message={t("subscribe_msg")}
                            handleClick={() => {
                              //setSubscribePopupMsg(t("subscribe_msg"));
                              setShowSubscribePopup(true);
                            }}
                          />
                        </div>
                      )}
                    </div>
                    <Desc
                      style={{ paddingTop: "4px" }}
                      className="d-flex gap-1"
                    >
                      <span>{t("driver_notifications_msg")}</span>
                      {tag === "free-user" && (
                        <span>{`(${t("paid_feature_str_sm")})`}</span>
                      )}
                    </Desc>
                  </Col>
                </Row>

                <Row>
                  <Col md={4}>
                    <FormGroupLabel>{t("first_notification")}</FormGroupLabel>
                    <Controller
                      name="firstNotification"
                      control={control}
                      //errors={errors}
                      render={({ field: { onChange, value, ref } }) => (
                        <Select
                          options={firstNotiOptions}
                          //value={vehicles.find((c) => c.value === value)}
                          value={value}
                          onChange={(val) => {
                            onChange(val);
                            setValue("secondNotification", null);
                            if (val) {
                              setSecondNotiOptions(
                                firstNotiOptions.filter(
                                  (option) => option.mins < val?.mins
                                )
                              );
                            }
                          }}
                          //onCreateOption={handleCreate}
                          placeholder={t("not_set")}
                          styles={formStyles}
                          isDisabled={tag === "free-user"}
                          isClearable
                        />
                      )}
                      //rules={{ required: t("required_err") }}
                    />

                    {errors?.firstNotification && (
                      <Error error={errors.firstNotification.message} />
                    )}
                  </Col>

                  <Col md={2}></Col>

                  <Col md={4}>
                    <FormGroupLabel>{t("second_notification")}</FormGroupLabel>
                    <Controller
                      name="secondNotification"
                      control={control}
                      //errors={errors}
                      render={({ field: { onChange, value, ref } }) => (
                        <Select
                          options={secondNotiOptions}
                          //value={vehicles.find((c) => c.value === value)}
                          value={value}
                          onChange={onChange}
                          //onCreateOption={handleCreate}
                          placeholder={t("not_set")}
                          styles={formStyles}
                          isDisabled={tag === "free-user" || !firstNotification}
                          isClearable
                        />
                      )}
                      //rules={{ required: t("required_err") }}
                    />

                    {errors?.secondNotification && (
                      <Error error={errors.secondNotification.message} />
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col md={10}>
                    <hr className="mt-4 mb-0 p-0" />
                  </Col>
                </Row>

                <Row>
                  <Col md={10}>
                    <FormGroupLabel>{t("trip_instr")}</FormGroupLabel>

                    <Controller
                      name="tripInstructions"
                      control={control}
                      //defaultValue={users?.length > 0 ? users[0] : ""}
                      //errors={errors}
                      render={({ field: { onChange, value, ref } }) => (
                        <AutoResizeTextArea
                          ref={textAreaRef}
                          onChange={onChange}
                          value={value}
                          placeholder={t("trip_instr_placeholder")}
                          rows={1}
                          //isDisabled={status == 1 || status == 2}
                        />
                      )}
                      //rules={{ required: t("required_err") }}
                    />

                    {errors?.tripInstructions && (
                      <Error error={errors.tripInstructions.message} />
                    )}
                  </Col>
                </Row>
              </>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ScheduledTripDetailsForm;
